import {
  GET_LOGIN,
  GET_PERMISSION,
  SET_SCROLL_LEFT,
  SET_SCROLL_TOP,
  CHANGE_SETTING,
  SET_SIZE
} from "./mutation-types";
import untils from "../untils";
import Cookies from "js-cookie";
export default {
  [GET_LOGIN](state, { login }) {
    //登录
    untils.setCookie("ssid", login.data.ID);
    untils.setCookie("username", login.data.USER_NAME);
    untils.setCookie("role_id", login.data.ROLE_ID);
    state.login = login.data;
    state.ssid = login.data.ID;
  },
  [GET_PERMISSION](state, { permission }) {
    //获取权限
    state.permissionList = permission.data.perms;
  },
  [SET_SCROLL_TOP](state, { scrollTop }) {
    state.scrollTop = scrollTop;
  },
  [SET_SCROLL_LEFT](state, { scrollLeft }) {
    state.scrollLeft = scrollLeft;
  },
  [CHANGE_SETTING](state, { key, value }) {
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  [SET_SIZE](state, value) {
    state.size = value;
    Cookies.set("fontsize", value);
  }
};
